import markItemReadInReadingPaneStore from '../actions/markItemReadInReadingPaneStore';
import markItemsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsReadStoreUpdate';
import { orchestrator } from 'satcheljs';

export default orchestrator(markItemsAsReadStoreUpdate, actionMessage => {
    const { itemIds, isReadValue } = actionMessage;
    itemIds.forEach(itemId => markItemReadInReadingPaneStore(itemId, isReadValue));
});
